import { Smartphone, CloudOff, WifiOff } from 'lucide-react';
import InstalarTego from '../integrador/pwa/InstalarTego';
import PendientesDeEnviar from '../integrador/pwa/PendientesDeEnviar';
import CobrarSinSenal from '../integrador/pwa/CobrarSinSenal';

/* =====================================================================
   Las pantallas del integrador · DIRECTRIZ-PWA F1 y F2 (11 oct 2026)
   =====================================================================
   «Instalar TEGO en tu teléfono» y «Pendientes de enviar» se montan desde
   aquí, sin tocar `ui/modulos.jsx` (caliente). Van en «Tu cuenta», junto
   a «Mi cuenta»: son de la persona y de su aparato, no de la empresa.
   «Cobrar sin señal» es un ajuste de la empresa (R-PWA-6): va en
   «Operación», junto a «Punto de venta», solo para administradores.
   `fundirGrupos` une cada uno al grupo que ya existe. El aviso de una
   línea bajo la cabecera lo engancha `AppShell` (`AvisoInstalar`).
   ===================================================================== */
export default {
  orden: 6,
  grupos: [
    {
      grupo: 'Tu cuenta',
      items: [
        {
          id: 'instalar-tego',
          etiqueta: 'Instalar TEGO en tu teléfono',
          icono: Smartphone,
          min: 'CONSULTA',
          Comp: InstalarTego,
        },
        {
          id: 'pendientes-de-enviar',
          etiqueta: 'Pendientes de enviar',
          icono: CloudOff,
          min: 'CONSULTA',
          Comp: PendientesDeEnviar,
        },
      ],
    },
    {
      grupo: 'Operación',
      items: [
        {
          id: 'cobrar-sin-senal',
          etiqueta: 'Cobrar sin señal',
          icono: WifiOff,
          min: 'ADMIN',
          soloEmpresa: true,
          Comp: CobrarSinSenal,
        },
      ],
    },
  ],
};
